import { render, staticRenderFns } from "./BlogTagPosts.vue?vue&type=template&id=16f350ce"
import script from "./BlogTagPosts.vue?vue&type=script&lang=js"
export * from "./BlogTagPosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports